import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'

import de from '@/locales/de/app.json'
import en from '@/locales/en/app.json'
import es from '@/locales/es/app.json'
import fr from '@/locales/fr/app.json'
import it from '@/locales/it/app.json'
import ja from '@/locales/ja/app.json'
import ko from '@/locales/ko/app.json'
import nl from '@/locales/nl/app.json'
import pl from '@/locales/pl/app.json'
import pt from '@/locales/pt/app.json'
import ru from '@/locales/ru/app.json'
import sv from '@/locales/sv/app.json'
import tr from '@/locales/tr/app.json'

export const APP_LANGUAGES = [
  {label: 'English (EN)', value: 'en', json: en},
  {label: 'Italiano (IT)', value: 'it', json: it},
  {label: 'Deutsch (DE)', value: 'de', json: de},
  {label: 'Español (ES)', value: 'es', json: es},
  {label: 'Français (FR)', value: 'fr', json: fr},
  {label: '日本語 (JA)', value: 'ja', json: ja},
  {label: '한국인 (KO)', value: 'ko', json: ko},
  {label: 'Nederlands (NL)', value: 'nl', json: nl},
  {label: 'Polski (PL)', value: 'pl', json: pl},
  {label: 'Português (PT)', value: 'pt', json: pt},
  {label: 'Русский (RU)', value: 'ru', json: ru},
  {label: 'Svenska(SV)', value: 'sv', json: sv},
  {label: 'Türkçe(TR)', value: 'tr', json: tr},
]

export const resources = {
  en: en,
  it: it,
  de: de,
  es: es,
  fr: fr,
  ja: ja,
  ko: ko,
  nl: nl,
  pl: pl,
  pt: pt,
  ru: ru,
  sv: sv,
  tr: tr,
} as const

export const defaultLang = 'en'

export const languagesList = APP_LANGUAGES.map((i) => i.value)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    parseMissingKeyHandler: () => {
      return ''
    },
    supportedLngs: APP_LANGUAGES.map((language) => language.value),
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

i18n.on('missingKey', (error) => console.error('i18n', error))

export default i18n
